// Classes
import { ProspectProfileReducerState } from "Containers/Filter/ProspectProfile/classes/prospectProfile.classes";
import { AttributeObject } from "../classes/attributes.classes";

/**
 * @function getGPAAttributes
 *
 * Post-processes the attributes for this section of the filter
 *
 * @param {ProspectProfileReducerState} prospectProfile - The current state
 * of the Prospect Profile filter section.
 * @return {AttributeObject | undefined}
 *
 * @example
 *
 *     getGPAAttributes(prospectProfile)
 */
export const getGPAAttributes = (
  prospectProfile: ProspectProfileReducerState
) => {
  let attributeObject = undefined;

  if (prospectProfile.gpa.selection !== "Any") {
    attributeObject = new AttributeObject(
      `GPA = ${prospectProfile.gpa.value.lower} - ${prospectProfile.gpa.value.upper}`,
      "standard"
    );
  }

  return attributeObject;
};
try {
    // @ts-ignore
    getGPAAttributes.displayName = "getGPAAttributes";
    // @ts-ignore
    getGPAAttributes.__docgenInfo = { "description": "", "displayName": "getGPAAttributes", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Attributes/utilities/getGPAAttributes.ts#getGPAAttributes"] = { docgenInfo: getGPAAttributes.__docgenInfo, name: "getGPAAttributes", path: "src/shared/containers/Attributes/utilities/getGPAAttributes.ts#getGPAAttributes" };
}
catch (__react_docgen_typescript_loader_error) { }